module.exports = __webpack_public_path__ + "static/media/Rectangle570.54c9a7e8.svg";